<table
  class="table table-striped table-bordered mb-3 mx-0"
  datatable
  [dtOptions]="dtOptions"
>
  <thead>
    <tr>
      <th *ngIf="isInfoIcon">
        {{ controlInfoHeader }}
      </th>
      <th *ngIf="isSelectAllCheckbox && isCheckbox">
        <input
          *ngIf="isSelectAllCheckbox"
          id="selectAllCheckboxId"
          type="checkbox"
          [checked]="isAllCheckboxChecked"
          (change)="selectAllCheckbox($event, records)"
        />
      </th>
      <th *ngIf="!isSelectAllCheckbox && isCheckbox">
        {{ controlCheckHeader }}
      </th>
      <th *ngIf="isRadioBox">{{ controlRadioHeader }}</th>
      <th *ngIf="linkData !== undefined && linkData !== null">
        {{ linkData.fieldInfo.label }}
      </th>

      <ng-container *ngFor="let map of columnMaps">
        <th
          [ngClass]="{
            hide: map.isKeyColumn === true,
            show: map.isKeyColumn === false
          }"
        >
          {{ map.fieldInfo.label }}
        </th>
      </ng-container>

      <th *ngIf="viewData !== undefined && viewData !== null">
        {{ viewData.fieldInfo.label }}
      </th>
      <th *ngIf="isDeleteOption" class="pr-2 text-center">
        Action
      </th>
    </tr>
  </thead>
  <tbody *ngIf="records.length > 0">
    <tr
      *ngFor="let record of records; let i = index"
      id="tableRow_{{ i }}"
      role="row"
    >
      <td *ngIf="isSelectAllCheckbox && isCheckbox">
        <div class="form-check pl-2 pr-2">
          <input
            id="checkBoxId_{{ i }}"
            type="checkbox"
            [checked]="record.checkboxChecked"
            (change)="selectCheckValue($event, record)"
          />
          <span class="form-check-sign">
            <span class="check"></span>
          </span>
        </div>
      </td>
      <td *ngIf="!isSelectAllCheckbox && isCheckbox">
        <div class="form-check pl-2 pr-2">
          <input
            id="checkBoxId_{{ i }}"
            type="checkbox"
            [checked]="record.checkboxChecked"
            (change)="selectCheckValue($event, record)"
          />
          <span class="form-check-sign">
            <span class="check"></span>
          </span>
        </div>
      </td>
      <td *ngIf="isRadioBox">
        <div class="form-check pl-2 pr-2">
          <div class="radio">
            <span>
              <input
                id="radioBoxId_{{ i }}"
                type="radio"
                name="selectedRow"
                [checked]="record.checked"
                (change)="selectRadioValue($event, record)"
              />
            </span>
          </div>
        </div>
      </td>
      <td *ngIf="isInfoIcon">
        <i
          (click)="infoLinkEmiiter($event, record)"
          class="fa fa-info-circle label-mark fa-lg"
          aria-hidden="true"
        ></i>
      </td>

      <td
        *ngIf="
          linkData !== undefined &&
          linkData !== null &&
          linkData?.alignment === 'currency'
        "
        [class]="linkData.alignItem"
      >
        <span
          ><a href="javascript:void(0);" (click)="selectedLink(record)">
            {{
              record[linkData.fieldInfo.fieldName]
                | gridCellFormatter: 'currency'
            }}
          </a>
        </span>
      </td>
      <td
        *ngIf="
          linkData !== undefined &&
          linkData !== null &&
          linkData?.alignment !== 'currency'
        "
        [class]="linkData.alignItem"
      >
        <span
          ><a href="javascript:void(0);" (click)="selectedLink(record)">
            {{ record[linkData.fieldInfo.fieldName] | titlecase }}
          </a>
        </span>
      </td>

      <ng-container *ngFor="let map of columnMaps">
        <td
          [class]="map?.alignItem"
          [ngClass]="{
            hide: map.isKeyColumn === true,
            show: map.isKeyColumn === false
          }"
        >
          <!-- <span *ngIf="map.columnType == 'link'"
          ><a href="javascript:void(0);" (click)="selectedLink(record)">
            {{ record[map.fieldInfo.fieldName] }}
          </a></span
        > -->
          <!-- <span *ngIf="map.columnType == 'view'">
          <button
            class="btn btn-primary btn-sm"
            (click)="viewRowRecords(record)"
            type="button"
          >
            Detail
          </button>
        </span> -->
          <span *ngIf="map.columnType != 'currency'">
            <span *ngIf="map.columnType == 'date'" style="display:none">
              {{ record[map.fieldInfo.fieldName] | date: 'yyyy/MM/dd' }}
            </span>
            {{
              record[map.fieldInfo.fieldName]
                | gridCellFormatter: map.columnType
            }}</span
          >

          <span *ngIf="map.columnType == 'currency'">
            {{ record[map.fieldInfo.fieldName] | currency: USD }}</span
          >
        </td>
      </ng-container>

      <td *ngIf="viewData !== undefined && viewData !== null">
        <button
          class="btn btn-primary btn-sm"
          (click)="viewRowRecords(record)"
          type="button"
        >
          Detail
        </button>
      </td>
      <td *ngIf="isDeleteOption" class="align-middle">
        <a href="javascript:void(0);" class="delete-link">
          <i
            class="fa fa-trash"
            (click)="deleteRow(record)"
            aria-hidden="true"
          ></i>
        </a>
      </td>
    </tr>
  </tbody>
  <tbody *ngIf="records.length === 0">
    <tr>
      <td class="bg-white">
        <h5>No Record Found</h5>
      </td>
    </tr>
  </tbody>
</table>
<!-- <div *ngIf="isCheckbox">
  <button class="btn btn-primary" (click)="saveSelectedValues()">
    Save Selected Values
  </button>
  &nbsp;
  <button class="btn btn-primary" (click)="resetCheckBox()">clear</button>
</div> -->
